/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Col, message, Row, Typography } from 'antd';
import { axiosErp } from 'shared/config/axios';

import { AppContext } from 'shared/context/AppContext';
import { getStoredAuthToken } from 'shared/utils/authToken';
import { HaierCostingStatus } from 'views/Costing/common/model/haierCostingStatus.model';
import { HaierCostingContext } from 'views/Costing/common/context/HaierCostingContext';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button } from 'shared/components';
import { useHistory } from 'react-router-dom';
import { StyledModal } from './Styles';

const { Text } = Typography;

type ModalConfirmCheckedProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmChecked: React.FC<ModalConfirmCheckedProps> = (props) => {
  const { onCancel, visible } = props;
  const token = getStoredAuthToken();
  const { userDetail } = useContext(AppContext);
  const { employeeId } = userDetail;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { selectedCostingDetail } = useContext(HaierCostingContext);
  const { modalConfirmChecked, costingId, backUrl } = selectedCostingDetail;
  const {
    costingNumber,
    refNumber,
    totalAfterDiscount,
    totalAfterDiscountSale,
  } = modalConfirmChecked;

  const closeModalHandler = () => {
    history.push(backUrl);
  };

  const confirmParcelCost = async () => {
    setLoading(true);
    try {
      await axiosErp(token).post(`update-costing-trip-turboo`, {
        filter: { _id: costingId },
        update: { costingStatus: HaierCostingStatus.APPROVED, employeeId },
      });
      setLoading(false);
    } catch (e) {
      message.error(e.message || 'เกิดข้อผิดพลาดในการยืนยันการตรวจสอบรายการราคา');
      console.error('ERROR TO LOAD COSTING DETAIL: ', e);
    } finally {
      message.success('ยืนยันการตรวจสอบรายการราคาเรียบร้อยแล้ว');
      setLoading(false);
      setTimeout(() => {
        closeModalHandler();
      }, 500);
    }
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ตรวจสอบรายการราคาแล้วใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="green"
          onClick={() => confirmParcelCost()}
          loading={loading}
        >
          ตรวจสอบแล้ว
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={5}>
          <Row>
            <Col span={24}>รหัสต้นทุน/ขาย</Col>
            <Col span={24}>
              <Text strong>{costingNumber || '-'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={9}>
          <Row>
            <Col span={24}>รหัสงานขนส่ง</Col>
            <Col span={24}>
              <Text strong>{refNumber || '-'}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>ต้นทุนก่อนภาษี</Col>
            <Col span={24}>
              <Text strong>{formatCurrency(totalAfterDiscount)}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>รายได้ก่อนภาษี</Col>
            <Col span={24}>
              <Text strong>{formatCurrency(totalAfterDiscountSale)}</Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmChecked;
